import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createChangeStatusNameCommand } from '../../../api/commands/factory/createStatusCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeStatusName extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ChangeStatusName';

    public constructor(public key: number, public name: string) {
        super(ChangeStatusName.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeStatusName): Promise<boolean> => {
    const status = state.subtaskStatuses.find((x) => x.key === action.key);
    return await useSendCommandAsync(action, {
        createCommand: async () => await createChangeStatusNameCommand(state.id, status.key, action.name),
    });
};

const reducer = (state: StorymapState, action: ChangeStatusName): void => {
    const status = state.subtaskStatuses.find((x) => x.key === action.key);

    status.name = action.name;
};

//@ts-ignore
registerMiddleware(ChangeStatusName.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeStatusName.ACTION_TYPE, reducer);
